import {TICKET_ADMIN_ROLES, TICKET_BACKOFFICE_ROLES} from "./ticket";

export const APPLICATION_TYPES = {company: "company", agency: "agency"};

export const APPLICATION_STATUSES = ["pending", "in_review", "approved", "rejected"];

export const APPLICATION_STATUS_COLORS = {
    pending: "blue",
    in_review: "orange",
    approved: "green",
    rejected: "red"
};

export const APPLICATION_ROLES = TICKET_BACKOFFICE_ROLES;

export const APPLICATION_COMPANY_EDIT_ROLES = [...TICKET_ADMIN_ROLES, "sales", "agency"];

// Bölge müdürlüğü listesi ucu yalnızca bu rollerde sorunsuz çalıştığından filtre yalnızca onlara gösterilir
export const APPLICATION_ZONE_MANAGEMENT_FILTER_ROLES = [...TICKET_ADMIN_ROLES, "bm"];

// Acente başvurusu yetkileri dinamik yetki politikalarıyla verilir (admin rolleri hariç)
export const APPLICATION_PERMISSION_KEYS = {
    viewAgency: "viewAgencyApplications",
    editAgency: "editAgencyApplications"
};

export const APPLICATION_MAX_NOTE_LENGTH = 2000;
